import CredentialsProvider from "next-auth/providers/credentials";
import GoogleProvider from "next-auth/providers/google";
import { NextRequest } from "next/server";
import { jwtDecode } from "jwt-decode";
import { JWT } from "next-auth/jwt";
import axios from "axios";
import { signOut } from "next-auth/react";
import { refreshAccessToken } from "./refreshAccessToken";
import { NextAuthOptions } from "next-auth";

type Credentials = {
    username: string,
    email: string,
    password: string,
    identifier:string,
    accessToken: string,
    accessCode: string,
};

const authProviders: NextAuthOptions = {
    session: {
        strategy: "jwt",
    },
    providers: [
        GoogleProvider({
            clientId: process.env.GOOGLE_ID!,
            clientSecret: process.env.GOOGLE_CLIENT_SECRET!
        }),
        CredentialsProvider({
            // @ts-ignore
            async authorize(credentials: Credentials, req: any) {
                const userAgent = req.headers['user-agent'];

                const { username, email, password, identifier, accessToken, accessCode } = credentials;

                console.log(credentials , '=========================');
                
                try {
                    if (accessCode) {
                        let config = {
                            method: 'get',
                            url: `${process.env.API_URL}/api/iam/google/authenticate?accessCode=${accessCode}`,
                            headers: {
                                'User-Agent': userAgent,
                            }
                        };
                        const loginResponse = await axios.request(config);
                        if (loginResponse.status == 400) {
                            throw new Error(loginResponse.data.message);
                        }
                        if (loginResponse.status == 401) {
                            throw new Error(loginResponse.data.message);
                        }

                        let base64decoded = jwtDecode(loginResponse.data.data.accessToken);
                        // let accessTokenExpires = base64decoded.exp;
                        let accessTokenExpires = base64decoded.exp && base64decoded.exp * 1000;

                        return {
                            accessToken: loginResponse.data.data.accessToken,
                            refreshToken: loginResponse.data.data.refreshToken,
                            accessTokenExpires: accessTokenExpires,
                            ...loginResponse.data.data,
                        };

                    } else {
                        if (accessToken) {
                            let data = JSON.stringify({
                                username: identifier,
                                email: identifier.includes('@')? identifier : null,
                                password: password
                            });

                            let config = {
                                method: 'get',
                                url: `${process.env.API_URL}/api/iam/me`,
                                headers: {
                                    'accept': '*/*',
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${accessToken}`
                                }
                            };


                            const loginResponse = await axios.request(config);

                            if (loginResponse.status == 400) {
                                throw new Error(loginResponse.data.message);
                            }
                            if (loginResponse.status == 401) {
                                throw new Error(loginResponse.data.message);
                            }
                            
                            let base64decoded = jwtDecode(accessToken);
                            // let accessTokenExpires = base64decoded.exp;
                            let accessTokenExpires = base64decoded.exp && base64decoded.exp * 1000;

                            return {
                                accessToken: accessToken,
                                refreshToken: loginResponse.data.data.refreshToken,
                                accessTokenExpires: accessTokenExpires,
                                ...loginResponse.data.data,
                            };

                        } else {

                            let data = JSON.stringify({
                                username: identifier,
                                email: identifier.includes('@')? identifier : null,
                                password: password
                            });

                            let config = {
                                method: 'post',
                                maxBodyLength: Infinity,
                                url: `${process.env.API_URL}/api/iam/authenticate`,
                                headers: {
                                    'accept': '*/*',
                                    'Content-Type': 'application/json',
                                    'User-Agent': userAgent,
                                },
                                data: data
                            };


                            const loginResponse = await axios.request(config);

                            // const authenticateResponse = await fetch(
                            //   `${process.env.API_URL}/api/iam/authenticate`,
                            //   {
                            //     method: "Post",
                            //     headers: {
                            //     'accept': '*/*', 
                            //       "Content-Type": "application/json"
                            //     },
                            //     body: JSON.stringify({
                            //       username: email,
                            //       email: email,
                            //       password: password
                            //     })
                            //   }
                            // );

                            // const loginResponse = await authenticateResponse.json();

                            // const response = await fetch(
                            //   `${process.env.API_URL}/api/iam/me`,
                            //   {
                            //     method: "Get",
                            //     headers: {
                            //       "Content-Type": "application/json",
                            //       "Authorization": `Bearer ${loginResponse.data.accessToken}`,
                            //     },
                            //   }
                            // );

                            // const responseData = await response.json();

                            if (loginResponse.status == 400) {
                                throw new Error(loginResponse.data.message);
                            }
                            if (loginResponse.status == 401) {
                                throw new Error(loginResponse.data.data.message);
                            }
                            let base64decoded = jwtDecode(loginResponse.data.data.accessToken);
                            // let accessTokenExpires = base64decoded.exp;
                            let accessTokenExpires = base64decoded.exp && base64decoded.exp * 1000;
                            const returnResponse = {
                                accessToken: loginResponse.data.data.accessToken,
                                refreshToken: loginResponse.data.data.refreshToken,
                                accessTokenExpires: accessTokenExpires,
                                ...loginResponse.data.data,
                            }
                            return returnResponse;
                        }
                    }
                } catch (error: any) {
                    throw new Error(error?.response?.data?.message);
                }
            },
        }),
    ],
    callbacks: {
        // @ts-ignore
        jwt: async ({ token, user }) => {
            // console.log("JWT callback called");
            const bufferTime = 60000;
            if (Date.now() >= (token.accessTokenExpires as number - bufferTime)) {
                // Call the refresh token function
                return await refreshAccessToken(token);
            }

            // If there is no user (first time login or session), we return the user data
            if (user) {
                // const base64decoded = jwtDecode(user.accessToken);
                // Convert from seconds to milliseconds
                // const accessTokenExpires = base64decoded.exp && base64decoded.exp * 1000; 
                // const accessTokenExpires = user.accessTokenExpires * 1000; 
                return {
                    ...token,
                    accessToken: user.accessToken,
                    refreshToken: user.refreshToken,
                    accessTokenExpires: user.accessTokenExpires,
                    user: user,  // Include the user data here
                };
            }

            return token; // If no update needed, just return the existing token
        },
        // @ts-ignore
        session: async ({ session, token }) => {
            // console.log("Session callback called");

            const user = token.user || {};  // Default to an empty object if user is undefined or null
            session.error = token.error ? token.error : null;
            // if (token.error) {
            //   return null
            // }
            session.user = {
                ...user, // Include the user info from the token
                accessToken: token?.accessToken,  // Add the access token to session for client use
                refreshToken: token?.refreshToken,  // Add refresh token to session for future use
                accessTokenExpires: token?.accessTokenExpires && token?.accessTokenExpires,  // Store the expiry time
            };
            return session;

        },
    },
    pages: {
        signIn: "/auth/login",
    },
    secret: process.env.NEXTAUTH_SECRET,
}

export default authProviders